import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=7cbffb3a"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cbffb3a')) {
      api.createRecord('7cbffb3a', component.options)
    } else {
      api.reload('7cbffb3a', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=7cbffb3a", function () {
      api.rerender('7cbffb3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Account.vue"
export default component.exports